import {mapActions, mapGetters, mapMutations} from 'vuex'
import router from '../../router'

const gameFlow = {
  computed: {
    ...mapGetters([
      'getGameFlowState',
      'getRedemptionMsisdn',
      'getSelectedCodeForRedemption',
      'getGameResponse',
      'getAccessToken',
      'getInGameFlow',
      'getTelcoValidRewardIds'
    ])
  },
  methods: {
    ...mapMutations([
      'updatePlayGameModal',
      'updateAcceptTermsModal',
      'updateInGameFlow',
      'updateGameFlowState',
      'updateGameResponse',
      'updateRedemptionMsisdn',
      'updateSelectedCodeForRedemption',
      'updateTopUpValue',
      'updateHasBeenAwarded',
      'updateAvailableSpins',
      'updateFoundBonusImage',
      'updateExtraChance',
      'updateSelectedTelcoReward',
      'updateDeliveryDetails',
      'updatePhysicalPrize',
      'updatePhysicalDisplayedPrize',
      'updateTelcoValidRewardIds',
      'updatePlayChances',
      'updatePlaysCount',
    ]),
    ...mapActions([
      'assignReward',
      'assignExtraChance',
      'getCodeForLoggedInCustomer',
      'networkRewardInfo'
    ]),
    gameRouting() {
      if (this.getGameFlowState === 'REDEEM') {
        this.updateAcceptTermsModal(true)
      } else if (this.getGameFlowState === 'SELECT_TELO_REWARD') {
        router.push({name: 'TelcoPrize'})
      } else if (this.getGameFlowState === 'PLAY_PHYSICAL_GAME') {
        router.push({name: 'SpinWheel'})
      } else if (this.getGameFlowState === 'DELIVERY_DATA_EVENT') {
        router.push({name: 'PhysicalPrize'})
      } else if (this.getGameFlowState === 'NO_CODES') {
        router.push({name: 'Account'})
      } else if (this.getGameFlowState === 'PLAY_FOR_EXTRA_CHANCE' || this.getAccessToken) {
        this.updateFoundBonusImage(false)
        this.assignExtraChance('SKIPPED_GAME')
          .then((response) => {
            this.$store.commit('updateAvailableSpins', response.data.params.playChances[1])
            this.$store.commit('updatePlayChances', response.data.params.playChances[1])
            const promoBundles = ['CR207', 'CR208', 'CR209', 'IR405']
            for (const code of promoBundles) {
              const flag = response.data.params['isPromoBundle' + code]
              if (flag) {
                this.$store.commit('updateIsPromoBundle' + code, flag)
                break
              }
            }
            router.push({name: 'SpinWheel'})
          })
          .catch(() => this.redirectUserOnError())
      }
    },
    createRewardIdParam(telcoRewardIds) {
      let rewardIdParam = ""
      let array = telcoRewardIds
      for (let i = 0; i < array.length; i++) {
        rewardIdParam += array[i].id
        if (i < array.length - 1) {
          rewardIdParam += ","
        }
      }
      return rewardIdParam
    },
    findCorrectTelcoType(telcoType) {
      for (let telco of this.getTelcoInfo) {
        if (telcoType === telco.telcoType) {
          this.selectedTelcoRewardId = telco.id
        }
      }
    },
    assignTelcoReward(wonPhysical, rewardId, extraChance) {
      this.assignReward(this.createTelcoData(rewardId, extraChance))
        .then(response => {
          this.$store.commit('updateGameResponse', response.data.params)
          this.$store.commit('updateExtraChance', response.data.params.physicalExtraChance)
          this.$store.commit('updateSelectedTelcoReward', response.data.params.selectedRewardId)
          if (!extraChance) {
            // todo: clean up relevant state values
            router.push({name: 'SocialShare'})
          } else {
            router.push({name: 'SpinWheel'})
          }
        })
        .catch((error) => {
          console.log('an error occurred: ' + error)
          this.redirectUserOnError()
        })
    },
    createTelcoData(rewardId, extraChance) {
      return {
        msisdn: this.getRedemptionMsisdn,
        code: this.getSelectedCodeForRedemption,
        rewardId: rewardId,
        extraChance: extraChance
      }
    },
    retrieveCodeForLoggedInCustomer() {
      this.getCodeForLoggedInCustomer()
        .then(response => {
          if (response.data === "NO_CODES") {
            this.$store.commit('updateGameFlowState', 'NO_CODES')
          } else {
            this.loadInfoFromConversation(response)
          }
          this.gameRouting()
        })
    },
    loadInfoFromConversation(response) {
      this.resetVariables()
      // case #1: choose game page
      // case #2: play for extra chance / pps game
      this.$store.commit('updateGameFlowState', response.data.currentConversationState)
      this.$store.commit('updateGameResponse', response.data.params)
      this.$store.commit('updateSelectedCodeForRedemption', response.data.params.code)
      if (response.data.params.eventTopupValue !== undefined) {
        this.$store.commit('updateTopUpValue', response.data.params.eventTopupValue[1] / 100)
      }
      // case #3: play physical game / spin the wheel
      if (response.data.currentConversationState !== 'REDEEM' || response.data.currentConversationState !== 'PLAY_FOR_EXTRA_CHANCE') {
        if (response.data.params.hasBeenAwarded !== undefined) {
          this.$store.commit('updateHasBeenAwarded', response.data.params.hasBeenAwarded)
        }
        if (response.data.params.playChances !== null && response.data.params.playChances !== undefined) {
          this.$store.commit('updatePlayChances', response.data.params.playChances[1])
          if (response.data.params.playsCount !== null && response.data.params.playsCount !== undefined) {
            this.$store.commit('updatePlaysCount', response.data.params.playsCount[1])
            this.$store.commit('updateAvailableSpins', response.data.params.playChances[1] - response.data.params.playsCount[1])
          } else {
            this.$store.commit('updateAvailableSpins', response.data.params.playChances[1])
          }
          if (response.data.params.playChances[1] - 1 === 0) {
            this.$store.commit('updateTelcoValidRewardIds', this.createRewardIdParam(response.data.params.validRewardIds[1]))
          }
        }
        // case #4: select telo reward
        if (response.data.params.physicalExtraChance !== undefined) {
          this.$store.commit('updateExtraChance', response.data.params.physicalExtraChance)
        }
        // case #5: select physical reward
        if (response.data.params.reservedRewards !== undefined) {
          this.$store.commit('updatePhysicalPrize', response.data.params.reservedRewards[1])
          if (response.data.params.displayedReward !== undefined) {
            this.$store.commit('updatePhysicalDisplayedPrize', response.data.params.displayedReward)
          }
        }

        const promoBundles = ['CR207', 'CR208', 'CR209', 'IR405']
        for (const code of promoBundles) {
          const flag = response.data.params['isPromoBundle' + code]
          if (flag) {
            this.$store.commit('updateIsPromoBundle' + code, flag)
            break
          }
        }
      }
    }
    ,
    telcoNetworkInfo(rewardIds) {
      this.networkRewardInfo(rewardIds)
        .then((response) => {
          this.$store.commit('updateTelcoInfo', response.data.customNetworkInfoApiList)
        })
    },
    resetGameState() {
      this.updateGameFlowState('')
      this.updateGameResponse([])
      this.updateSelectedCodeForRedemption(null)
      this.updateTopUpValue(0)
      this.updateHasBeenAwarded(false)
      this.updateAvailableSpins(0)
      this.updateExtraChance(false)
      this.updateSelectedTelcoReward([])
      this.updateDeliveryDetails({})
      this.updatePhysicalPrize([])
      this.updatePhysicalDisplayedPrize({})
      this.updatePlayChances(0)
      this.updatePlaysCount(0)

    },
    resetVariables() {
      this.updatePlayChances(0)
      this.updatePlaysCount(0)
    },
    setInGameFlow(value, routePath) {
      this.updateInGameFlow(value)
      localStorage.setItem('routePath', routePath)
    },
    redirectUserOnError() {
      if (this.getAccessToken) {
        router.push({name: 'Account'})
      } else {
        router.push({name: 'Home'})
      }
    }
  }
}

export default gameFlow



// WEBPACK FOOTER //
// ./src/common/mixin/gameFlow.js